import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class NuSVCGraph extends AbstractScatterVisualization {
}
